export default __webpack_public_path__ + "static/SegoeUI-Bold-62f56c089745418bb37355115d5f7c60.ttf";